import { Select, Spin } from "antd";
import React, { useCallback, useState } from "react";
import { apiCustomer } from "../../../../api/api-customer";

const { Option } = Select;

const Customer = ({ setFieldsValue, name }) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchUser = (value) => {
    setLoading(true);
    apiCustomer
      .customerSuggest({ name: `%${value}%` }, 1)
      .then((res) => {
        if (res.status === "success") {
          setOptions(
            res.data.content.map((i) => ({
              value: i.customer_id,
              label: i.name,
            }))
          );
        }
      })
      .finally(() => setLoading(false));
  };

  const onChange = useCallback(
    (values) => {
      !!setFieldsValue &&
        setFieldsValue({
          [name]: {
            id_in: values.length > 0 ? values.map((i) => i.value) : null,
          },
        });
    },
    [setFieldsValue]
  );

  return (
    <Select
      mode="multiple"
      showArrow
      placeholder="Khách hàng"
      labelInValue
      notFoundContent={loading ? <Spin size="small" /> : null}
      filterOption={false}
      onChange={onChange}
      onSearch={fetchUser}
    >
      {options.map((item, index) => (
        <Option value={item.value} key={index}>
          {item.label}
        </Option>
      ))}
    </Select>
  );
};

export default Customer;
